import React, { Fragment, useEffect, useState } from "react";
import {
  Button,
  Col,
  Form,
  FormFeedback,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalHeader,
  Row,
  UncontrolledTooltip,
} from "reactstrap";

// redux toolkit
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import {
  fetchAnnouncement,
  updateAnnouncement,
} from "../../slices/apps/announcementSlice";

// Formik validation
import * as Yup from "yup";
import { useFormik } from "formik";

// diğer importlar
import { useDropzone } from "react-dropzone";

const AnnouncementUpdateModal = ({ id }) => {
  const dispatch = useDispatch();
  const [preview, setPreview] = useState(null);

  const [modal, setModal] = useState(false);

  const { announcement, updateAnnouncementLoading } = useSelector((state) => {
    return {
      announcement: state.announcement.announcement,
      updateAnnouncementLoading: state.announcement.updateAnnouncementLoading,
    };
  }, shallowEqual);

  const fetchData = async () => {
    try {
      const resultAction = await dispatch(fetchAnnouncement(id));

      if (resultAction.meta.requestStatus === "fulfilled") {
        validation.resetForm();

        if (resultAction.payload?.AnnouncementImageUrl) {
          setPreview(
            "https://api.globalyolyardim.com/" +
              resultAction.payload.AnnouncementImageUrl,
          );
        }

        setModal(true);
      }
    } catch (error) {
      console.error("Failed:", error);
    }
  };

  function tog_large(e) {
    if (e) {
      fetchData();
    } else setModal(false);
  }

  const validation = useFormik({
    enableReinitialize: true,

    initialValues: {
      id: id,
      announcementTitle: announcement?.AnnouncementTitle || "",
      announcementContent: announcement?.AnnouncementContent || "",
      isDefault: announcement?.IsDefault || false,
      announcementImage: null,
    },

    validationSchema: Yup.object({
      announcementTitle: Yup.string().required("Başlık zorunludur"),
      announcementContent: Yup.string().required("İçerik zorunludur"),
    }),

    onSubmit: async (values) => {
      const resultAction = await dispatch(updateAnnouncement(values));

      console.log(values);

      if (resultAction.meta.requestStatus === "fulfilled") {
        setModal(false);
      }
    },
  });

  useEffect(() => {
    return () => {
      if (preview) {
        URL.revokeObjectURL(preview);
      }
    };
  }, [preview]);

  const { getRootProps, getInputProps } = useDropzone({
    accept: { "image/*": [] },
    onDrop: (acceptedFiles) => {
      const file = acceptedFiles[0];
      validation.setFieldValue("announcementImage", file);

      if (preview && !preview.startsWith("http")) {
        URL.revokeObjectURL(preview);
      }

      const previewUrl = URL.createObjectURL(file);
      setPreview(previewUrl);
    },
  });

  return (
    <Fragment>
      <span
        id={`announcement-update-tooltipTop-${id}`}
        style={{
          display: "flex",
          cursor: "pointer",
          padding: "3px",
        }}
        onClick={() => tog_large(true)}
      >
        <i
          className="bx bx-edit text-dark"
          style={{
            fontSize: "20px",
          }}
        />
      </span>

      <UncontrolledTooltip
        placement="top"
        target={`announcement-update-tooltipTop-${id}`}
      >
        Duyuru Bilgilerini Düzenle
      </UncontrolledTooltip>

      <Modal
        size="lg"
        centered={true}
        isOpen={modal}
        toggle={() => {
          setModal(false);
        }}
      >
        <ModalHeader
          className="modal-title "
          id="myLargeModalLabel"
          toggle={() => {
            setModal(false);
          }}
        >
          Duyuru Bilgilerini Düzenle
        </ModalHeader>

        <ModalBody>
          <Form action="#" autoComplete="off">
            <Row className="align-items-start gy-3">
              <Col lg={12}>
                <Label htmlFor="announcementTitle" className="form-label">
                  Başlık
                </Label>
                <Input
                  name="announcementTitle"
                  className="form-control"
                  placeholder="Başlık"
                  type="text"
                  autoComplete="off"
                  onChange={validation.handleChange}
                  onBlur={validation.handleBlur}
                  value={validation.values.announcementTitle || ""}
                  invalid={
                    validation.touched.announcementTitle &&
                    validation.errors.announcementTitle
                      ? true
                      : false
                  }
                />
                {validation.touched.announcementTitle &&
                  validation.errors.announcementTitle && (
                    <FormFeedback type="invalid">
                      {validation.errors.announcementTitle}
                    </FormFeedback>
                  )}
              </Col>

              <Col lg={12}>
                <Label htmlFor="announcementContent" className="form-label">
                  İçerik
                </Label>
                <Input
                  name="announcementContent"
                  className="form-control"
                  placeholder="Duyuru içeriğini giriniz"
                  type="textarea"
                  autoComplete="off"
                  rows="5"
                  onChange={validation.handleChange}
                  onBlur={validation.handleBlur}
                  value={validation.values.announcementContent || ""}
                  invalid={
                    validation.touched.announcementContent &&
                    validation.errors.announcementContent
                      ? true
                      : false
                  }
                  style={{ resize: "none" }}
                />
                {validation.touched.announcementContent &&
                  validation.errors.announcementContent && (
                    <FormFeedback type="invalid">
                      {validation.errors.announcementContent}
                    </FormFeedback>
                  )}
              </Col>

              <Col xs={12}>
                <div
                  {...getRootProps()}
                  style={{
                    border: "1px dashed #aaa",
                    padding: "30px",
                    borderRadius: "8px",
                    textAlign: "center",
                    cursor: "pointer",
                  }}
                  className="mt-3 mb-3"
                >
                  <input {...getInputProps()} />
                  <p className="mb-0">Görseli buraya bırak veya tıkla</p>
                  {preview && (
                    <div className="mt-2" style={{ display: "inline-block" }}>
                      <img
                        src={preview}
                        alt="preview"
                        className="img-fluid rounded"
                        style={{
                          maxHeight: "300px",
                        }}
                      />
                    </div>
                  )}
                </div>
                {preview && (
                  <div className="mt-2 text-start">
                    <Button
                      color="danger"
                      size="sm"
                      type="button"
                      onClick={() => {
                        setPreview(null);
                        validation.setFieldValue("announcementImage", null);
                      }}
                    >
                      <i className="bx bx-trash me-1"></i>
                      Görseli Kaldır
                    </Button>
                  </div>
                )}
              </Col>

              <Col sm={12}>
                <ul className="list-unstyled mb-0">
                  <li className="d-flex">
                    <div className="flex-grow-1">
                      <label
                        htmlFor="isDefault"
                        className="form-check-label fs-13"
                      >
                        Aktif
                      </label>
                    </div>
                    <div className="flex-shrink-0">
                      <div className="form-check form-switch">
                        <Input
                          name="isDefault"
                          className="form-check-input"
                          type="checkbox"
                          role="switch"
                          id="isDefault"
                          checked={validation.values.isDefault || false}
                          onChange={(e) => {
                            validation.handleChange(e);
                          }}
                        />
                      </div>
                    </div>
                  </li>
                </ul>
              </Col>
            </Row>

            <div className="d-flex align-items-center gap-3 mt-4">
              <Button
                className="btn btn-sm ms-auto nexttab nexttab"
                color="primary"
                type="button"
                onClick={() => {
                  validation.handleSubmit();
                }}
                disabled={updateAnnouncementLoading}
              >
                Kaydet
              </Button>
            </div>
          </Form>
        </ModalBody>
      </Modal>
    </Fragment>
  );
};

export default AnnouncementUpdateModal;
